import { channel } from 'ducks/entities/schema'

export const createWidgetGraphQlResponseSchema = {
  widget: channel,
}
